<template>
  <div
    class="d-flex align-items-end position-absolute w-100 h-100 cover-overlay flex-wrap"
  >
    <TournamentsListPinnedItem :tournament="account" class="w-100 h-100" />
  </div>
</template>

<script>
import TournamentsListPinnedItem from '@/views/tournaments/list/Pinned/item.vue';
import { mapState } from 'vuex';
export default {
  name: 'TournamentCoverOverlay',
  components: {
    TournamentsListPinnedItem,
  },
  computed: {
    ...mapState('current', ['account']),
  },
};
</script>
